module.exports = __webpack_public_path__ + "static/media/wine_glass.dfce017b.png";